import goodsApi from '@/api/goods'

const goods={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editGood:{},
    sorter:{},
    category:[]
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.disabled=false
      state.editGood=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setCategory:(state,category)=>{
      state.category=category
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await goodsApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },goods){
      try{
        if(goods.id){
          await goodsApi.update(goods)          
        }else{
          await goodsApi.create(goods)
        }
        commit('edit',{})
        await dispatch('GetAll',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch,state },goods){
      await goodsApi.delete(goods.id)
      await dispatch('GetAll',state.pagination)
    },
    async Get({ commit },id){
      const res=await goodsApi.get(id)
      commit
      return res.result
    },
    async GetCategory({ commit }){
      const res=await goodsApi.getCategory()
      commit('setCategory',res.result)
    },
    async CreateCategory({commit},input){
      await goodsApi.createCategory(input)
      commit
    }
  }
}
export default goods